// extracted by mini-css-extract-plugin
export default {"Emojis__item":"bgj_a bii_wj bii_ss bii_xl"};